export {
  SliderWrapper,
  Component,
  Header,
  PaginationWrapper,
  NavButtons,
  NavButton,
} from './SliderWrapper';
